import Vue from 'vue';
import Api from '@/config/api';

export default {
  state: {
    contacts: [],
    currentPage: 1,
    itemsPerPage: 5, // Set the number of items per page as needed
    totalContacts: null,
    contactCount: null,
    unReadContactCount: null,
  },
  mutations: {
    setContacts(state, contacts) {
      state.contacts = contacts;
    },
    setPage(state, page) {
      state.currentPage = page;
    },
    setTotalContacts(state,total) {
        state.totalContacts = total;
    },
    setContactCount(state,data){
        state.contactCount = data;
    },
    setUnreadContact(state,data){
        state.unReadContactCount = data;
    }
  },
  getters: {
    getContacts(state){
        return state.contacts;
    },
    getPage(state){
        return state.currentPage;
    },
    getItemsPerPage(state) {
        return state.itemsPerPage;
    },
    getTotalContacts(state) {
        return state.totalContacts;
    },
    getContactCount(state) {
        return state.contactCount;
    },
    getUnreadContactCount(state) {
        return state.unReadContactCount
    }
  },
  actions: {
    async loadContacts({commit},page){
        try {
            await Vue.auth.getToken();
            const contacts = await Vue.axios({
                method: 'get',
                url: Api.url(`${Api.endpoints.allMessages}?page=${page}&limit=5`)
            });
            // console.log(contacts);
            commit('setContacts', contacts.data.data);
            commit('setTotalContacts', contacts.data.meta.totalDocuments);
        } catch (err) {
            console.log(err);
        }
    },
    async loadContactCount({commit}) {
        try {
            await Vue.auth.getToken();
            const contacts = await Vue.axios({
                method: 'get',
                url: Api.url(Api.endpoints.totalContacts),
            });
            // console.log(contacts.data.data);
            commit('setContactCount', contacts.data.data.totalContacts);
            commit('setUnreadContact', contacts.data.data.unreadContacts)
        } catch(err) { 
            console.log(err);
        }
    }
  },
};
